import { PaymentSettings } from '../../api/api';

export const getDepositLabel = (config: PaymentSettings) => {
  if (config.config === 'deposit') {
    return config.depositSettings.type === 'fixed'
      ? 'Deposit due today:'
      : `Deposit due today (${100 * config.depositSettings.amount}%):`;
  }
  return '';
};

export const getDepositAmount = (config: PaymentSettings, total: number) => {
  if (config.config === 'deposit') {
    if (config.depositSettings.type === 'fixed') {
      const depositAmount = Number(config.depositSettings.amount) * 100;
      return depositAmount > total ? total : depositAmount;
    }
    if (config.depositSettings.type === 'percentage') {
      return total * config.depositSettings.amount;
    }
    return 0;
  }
  return 0;
};
